<ng-container>
  <ng-container *ngIf="href; else buttonTemplate">
    <hdi-link
      [href]="href"
      [target]="target"
      [label]="label | capitalize"
      [hrefType]="hrefType"
      [rel]="linkRel ?? ''"
      [title]="linkTitle"
      [fragment]="fragment"
      [type]="LinkType.NOSTYLES"
      [attr.data-type]="type"
      [attr.data-viewport]="viewport"
      [ngClass]="{
        'expand-button': expandButton,
        'shrink-button': shrinkButton,
        'large-rounded-button': sizes,
        'label-reverse': isNavigationIcon,
        open: isOpen,
      }"
      [iconName]="getIconName()"
      [iconPrefix]="getIconPrefix()"
      [bold]="bold"
      [sizes]="sizes"
    >
    </hdi-link>
  </ng-container>

  <ng-template #buttonTemplate>
    <button
      [ngClass]="{ reverse: isNavigationIcon }"
      [attr.data-type]="type"
      aria-label=""
      [disabled]="disabled"
      [ngStyle]="
        outline
          ? { outline: '2px solid ' + outlineColor }
          : outline === false
            ? { outline: '0' }
            : {}
      "
      [ngClass]="{
        reverse: isNavigationIcon,
        'expand-button': expandButton,
        'shrink-button': shrinkButton,
        'large-rounded-button': sizes,
        'label-reverse': isNavigationIcon,
        open: isOpen,
      }"
      (click)="handleClick($event)"
    >
      <!-- Disabled Label -->
      <span
        *ngIf="shouldDisplayLabel() && disabled"
        class="label"
        [innerHTML]="label"
      ></span>

      <!-- Display first icon -->
      <ng-container
        *ngIf="shouldDisplayLeftIcon() && !isWithoutIcon"
        class="first_icon"
      >
        <hdi-icon
          [iconName]="getIconName(true)"
          [iconPrefix]="getIconPrefix()"
          [size]="sizes"
        ></hdi-icon>
      </ng-container>

      <!-- Projected Content -->
      <ng-content></ng-content>

      <!-- Display second icon -->
      <ng-container *ngIf="shouldDisplayRightIcon() && !isWithoutIcon">
        <hdi-icon
          [iconName]="getIconName()"
          [iconPrefix]="getIconPrefix()"
          [class.flip]="iconName && iconName === 'chevron-down' && isOpen"
          [size]="sizes"
        ></hdi-icon>
      </ng-container>

      <!-- Navigation Label -->
      <ng-container *ngIf="shouldDisplayLabel() && !disabled">
        <span
          class="label-reverse"
          [ngStyle]="{ 'font-weight': bold ? 'bold' : 'normal' }"
          [innerHTML]="label"
        >
        </span>
      </ng-container>
    </button>
  </ng-template>
</ng-container>
